'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _InlineDonate = require('./InlineDonate.css');

var _InlineDonate2 = _interopRequireDefault(_InlineDonate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineDonate = (_dec = (0, _reactCssModules2.default)(_InlineDonate2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(InlineDonate, _Component);

  function InlineDonate() {
    (0, _classCallCheck3.default)(this, InlineDonate);
    return (0, _possibleConstructorReturn3.default)(this, (InlineDonate.__proto__ || (0, _getPrototypeOf2.default)(InlineDonate)).apply(this, arguments));
  }

  (0, _createClass3.default)(InlineDonate, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'inline-donate', 'aria-labelledby': 'inline-donate__headline' },
        _react2.default.createElement(
          'div',
          { styleName: 'inline-donate__icon', 'aria-hidden': 'true' },
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-heart', nospace: true })
        ),
        _react2.default.createElement(
          'h3',
          { id: 'inline-donate__headline', styleName: 'inline-donate__headline' },
          'Support our work'
        ),
        _react2.default.createElement(
          'h3',
          { styleName: 'inline-donate__copy' },
          'Your gift helps hold corporations accountable. Make a difference \u2014 donate today.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'inline-donate__link' },
          _react2.default.createElement(
            _components.Link,
            {
              to: _config2.default.links.donate,
              title: 'Donate to As You Sow',
              donatebanner: true
            },
            'Donate'
          )
        )
      );
    }
  }]);
  return InlineDonate;
}(_react.Component)) || _class);
exports.default = InlineDonate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/InlineDonate/InlineDonate.js
// module id = 1361
// module chunks = 0